import React, {useEffect} from "react"
import axios from "axios"
import { Helmet } from "react-helmet";

import Layout from "../components/layout";
import SEO from "../components/seo";

import InsightsLinks from "../components/InsightsDetails/InsightsLinks";
import Management from "../components/InsightsDetails/PortfolioManagement/Management";
import YouMayAlsoLike  from '../components/Home/News/SimilarNews'
import {capitalize} from '../components/common/utils';

import BrandLogo from "../images/logo002.svg";

function InsightDetailsTemplate(props) {

  const news_details = props.pageContext.data;

  useEffect(() => {
    if (news_details?.id) {
      axios.post('/api/increment-views', {
        id: news_details.id,
        currentViewers: news_details.viewers || 0,
        collection: 'news-and-insights'
      }).catch(() => {});
    }
  }, []);

  var myMetaTitle = "";
  var myMetaDesc = "";
  var myMetaImg = "";

  if( props?.pageContext?.title ) {
      myMetaTitle = capitalize(props.pageContext.title);
      myMetaDesc = "Read about "+myMetaTitle+" here and subscribe to our newsletter to stay up-to-date about everything going on at Strettons.";
  }

  let processedImages = JSON.stringify({});
  const STAGE_ENV = process.env.GATSBY_STRAPI_GGFX_ENV || "i.dev";

  if (news_details?.imagetransforms?.Image_Transforms) {
    processedImages = news_details?.imagetransforms?.Image_Transforms;
    var resized_images = JSON.parse(processedImages);
    const SrcCftle = news_details?.Image && news_details?.Image?.url.substring(news_details?.Image && news_details?.Image?.url.indexOf(STAGE_ENV));
    const ProcessedUrl = resized_images[SrcCftle] && resized_images[SrcCftle]?.jpg ? resized_images[SrcCftle]?.jpg['472x300'] :
                         resized_images[SrcCftle]?.png ? resized_images[SrcCftle]?.png['472x300'] : news_details?.Image && news_details?.Image?.url;
    myMetaImg = ProcessedUrl;
  }

  const insightUrl = `${process.env.GATSBY_SITE_URL?.replace(/\/+$/, "") || ""}/insights/${news_details?.URL || props.pageContext?.slug || ""}/`.replace(/([^:]\/?)\/+/g, "$1");
  const insightDescription = news_details?.Highlight_Text || myMetaDesc || "Read about this insight and subscribe to our newsletter to stay up-to-date about everything going on at Strettons.";
  const insightSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": insightUrl
    },
    "headline": news_details?.Title || myMetaTitle,
    "description": insightDescription,
    "image": myMetaImg || (news_details?.Image?.url || ""),
    "author": {
      "@type": "Organization",
      "name": "Strettons"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Strettons",
      "logo": {
        "@type": "ImageObject",
        "url": `${process.env.GATSBY_SITE_URL?.replace(/\/+$/, "") || ""}/images/strettons-logo.svg`
      }
    },
    "datePublished": news_details?.Published_Date || "",
    "dateModified": news_details?.Published_Date || ""
  };

  return (
      <Layout GQLPage="" Layout="Without_Banner" classNames={"search-header person-header news_details_wrapper details-header"} popular_search_slug="insights">

        <SEO title={myMetaTitle} description={myMetaDesc} image={myMetaImg}/>
        
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(insightSchema)}</script>
        </Helmet>
        
        <Helmet bodyAttributes={{ class: `body_cls` }} />

        <InsightsLinks page_title={news_details && news_details.Title} />

        {news_details && <Management news_details={news_details} /> }

        <YouMayAlsoLike CustomTitle={"You may also like..."} news_id={news_details?.id} category={news_details && news_details?.news_and_insights_category?.Name} />

      </Layout>
  )
}

export default InsightDetailsTemplate
